/**
 * Clase del pin SVG (sin "svg-marker") → code_text de la estación.
 * Así cada pin abre una estación concreta aunque varias compartan marker en Dynamo.
 */
export const MAP_PIN_TO_CODE = {
  "baja-california": "TIJ",
  "baja-california-mxl": "MXL",
  sonora: "HMO",
  "sonora-cen": "CEN",
  chihuahua: "CJS",
  "chihuahua-cuu": "CUU",
  sinaloa: "CUL",
  "sinaloa-mzt": "MZT",
  "sinaloa-lmm": "LMM",
  "baja-california-sur": "LAP",
  "baja-california-sur-sjd": "SJD",
  jalisco: "GDL",
  "jalisco-pvr": "PVR",
  aguascalientes: "AGU",
  "san-luis-potosi": "SLP",
  guanajuato: "BJX",
  queretaro: "QRO",
  "edomex-gustavo-baz": "MEX2",
  "cdmx-sarabia": "MEX1",
  "cdmx-hangares": "MEX3",
  guerrero: "ZIH",
  puebla: "PBC",
  veracruz: "VER",
  "veracruz-mtt": "MTT",
  oaxaca: "OAX",
  chiapas: "TGZ",
  "chiapas-tap": "TAP",
  tabasco: "VSA",
  campeche: "CPE",
  "campeche-cme": "CME",
  yucatan: "MID",
  "quintana-roo": "CUN",
  durango: "DGO",
  coahuila: "TRC",
  "nuevo-leon": "MTY",
  tamaulipas: "REX",
  "tamaulipas-tam": "TAM",
};

export function getStationCodeForPinKey(keyRaw) {
  const key = String(keyRaw || "")
    .toLowerCase()
    .trim();
  return MAP_PIN_TO_CODE[key] || null;
}

export function getPinKeysForStationCode(codeText) {
  const code = String(codeText || "")
    .trim()
    .toUpperCase();
  if (!code) return [];
  return Object.entries(MAP_PIN_TO_CODE)
    .filter(([, c]) => c === code)
    .map(([k]) => k);
}
